import React from "react";
import "./style.scss";

export default class PopupComp extends React.Component {
  constructor(props) {
    super(props);
    this.bodyTag = document.getElementsByTagName("body")[0];
  }

  handleRemoveClass = () => {
    this.props.isPopup();
    this.bodyTag.classList.remove("isPopup");
  };

  render() {
    let { show, className, children, width = "" } = this.props;

    if (!show) {
      this.bodyTag.classList.add("isPopup");
      return (
        <div className="popup_comp">
          <div className="table">
            <div className="table-cell">
              <div
                className={`popup_box ${className ? className : ""}`}
                style={{ width }}
              >
                <i
                  className="popup_close fa fa-close"
                  onClick={this.handleRemoveClass}
                />
                {children}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      this.bodyTag.classList.remove("isPopup");
      return <div className={className}>{children}</div>;
    }
  }
}
